import { apiGet, apiPost, apiPut } from "@redriver/cinnamon";

const NAMESPACE = "CLIENT/SIGNATORY";

const ActionTypes = {
  GetClientAuthorisedSignatory: `${NAMESPACE}/GET_CLIENT_AUTHORISED_SIGNATORY`,
  UpdateClientAuthorisedSignatory: `${NAMESPACE}/UPDATE_CLIENT_AUTHORISED_SIGNATORY`,
  RejectClientAuthorisedSignatory: `${NAMESPACE}/REJECT_CLIENT_AUTHORISED_SIGNATORY`,
  ArchiveClientAuthorisedSignatory: `${NAMESPACE}/ARCHIVE_CLIENT_AUTHORISED_SIGNATORY`,
  UnarchiveClientAuthorisedSignatory: `${NAMESPACE}/UNARCHIVE_CLIENT_AUTHORISED_SIGNATORY`,
};

export const getClientAuthorisedSignatory = ({ signatoryId, clientId }) =>
  apiGet(
    ActionTypes.GetClientAuthorisedSignatory,
    `clients/${clientId}/authorised-signatories/${signatoryId}`,
  );

export const updateClientAuthorisedSignatory = (
  data,
  { signatoryId, clientId },
) =>
  apiPut(
    ActionTypes.UpdateClientAuthorisedSignatory,
    `clients/${clientId}/authorised-signatories/${signatoryId}`,
    data,
  );

export const rejectClientAuthorisedSignatory = (
  data,
  { signatoryId, clientId },
) =>
  apiPost(
    ActionTypes.RejectClientAuthorisedSignatory,
    `clients/${clientId}/authorised-signatories/${signatoryId}/reject`,
  );

export const archiveClientAuthorisedSignatory = (
  data,
  { signatoryId, clientId },
) =>
  apiPost(
    ActionTypes.ArchiveClientAuthorisedSignatory,
    `clients/${clientId}/authorised-signatories/${signatoryId}/archive`,
  );

export const unarchiveClientAuthorisedSignatory = (
  data,
  { signatoryId, clientId },
) =>
  apiPost(
    ActionTypes.ArchiveClientAuthorisedSignatory,
    `clients/${clientId}/authorised-signatories/${signatoryId}/unarchive`,
  );
